export default __webpack_public_path__ + "static/media/dummy-google-workspace-bulk.4b799670.png";